/* eslint-disable */
<template>
  <div class="hello">

    <div
      class="modal is-active"
      v-show="showEditUserModal"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Bitte Daten neu eingeben </p>
          <button
            class="delete"
            aria-label="close"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class=" field ">

            <input
              class="input"
              type="text"
              v-model="displayName"
              placeholder="Name"
              required
            ><br><br>
            <input
              class="input"
              type="text"
              v-model="telNumber"
              placeholder="Natelnummer"
              required
            ><br>
            <!-- <input type="text" placeholder="T-Shirt Grösse"><br> -->
            <p>Shirt</p>

            <select
              class="select"
              v-model="shirtsize"
              required
            >
              <option value="xs">XS</option>
              <option value="s">S</option>
              <option value="m">M</option>
              <option value="l">L</option>
              <option value="xl">XL</option>
              <option value="xxl">XXL</option>

            </select>
            <br>
            <br>

            <button
              class="button is-success"
              v-on:click="signUp"
            >Update</button>

          </div>
        </section>
        <!-- <footer class="modal-card-foot">
          <button class="button is-success">Save changes</button>
          <button class="button">Cancel</button>
        </footer> -->
      </div>
    </div>

    <h1>Helferanmeldung Musikwelle Guggach 2019</h1>
    <div class="column ">
      <div class="card card-shadow ">

        <div
          v-for="person in contacts"
          :key="person.id"
        >
          <header class="card-header">
            <p
              class="card-header-title"
              style="display: block"
            >
              Hallo {{person.name}}

            </p>
          </header>
          <div class="card-content">
            <div class="content">

              <div class="inner">
                <div class="left">
                  <p class="user-list__sub">Deine angegebene Mailadresse ist
                    <strong>{{person.email}}</strong>
                  </p>
                </div>
                <div class="right">
                  <p class="user-list__sub">und unter
                    <strong>{{person.telNumber}}</strong> können wir dich bei kurzfristigen Änderungen erreichen.</p>
                </div>
                <div class="right">
                  <p class="user-list__sub">Dein Helfer-Shirt bekommst du in der Grösse
                    <strong>{{person.shirtsize}}</strong>
                  </p>
                </div>
                <div class="right">
                  <p class="user-list__sub">(Falls diese Daten nicht stimmen, schreib uns ein Mail an helfer@chornhuus.ch)

                  </p>
                </div>
                <br>
                <div class="right">
                  <p class="user-list__sub">
                    <strong>Deine angemeldeten Schichten </strong>
                  </p>
                  <table class="table is-striped is-hoverable">
                    <thead>
                      <tr>

                        <td>Bereich</td>
                        <td>Tag</td>
                        <td>Zeit</td>

                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="object in table"
                        :key="object.id"
                      >
                        <td>{{object.bereich}}</td>
                        <td>{{object.tag}}</td>
                        <td>{{object.zeit}}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <h1>Allgemeine Infos</h1>
    <p>Die diesjährige Musikwelle Guggach findet am 6. und 7. September 2019 statt - schön, dass du als Helfer mit dabei bist! <br>
      Die untenstehenden Helferschichten sind in "real time" dargestellt. Wenn du dich für eine Schicht eingetragen hast, bist du dafür fix eingeteilt. Bis zum 25.08.19 kannst du jedoch selbständig Änderungen vornehmen.<br><br>

      Die unten angegebenen Zeiten sind die effektiven Schichtzeiten. Rechne fürs Ankommen und die Instruktion jeweils 30 Minuten dazu. <br>
      Als Dankeschön für deinen Einsatz gibt's ein Helfershirt, 2 Getränke- und 1 Essensbon.<br><br>

      Bei Fragen meldest du dich unter helfer@chornhuus.ch<br>
      Weitere Infos folgen per Helfermail eine Woche vor dem Fest.<br><br>

      Nice to know: <br>
      Alle Helfer, die sich bis zum 01.08.19 eintragen, kommen mit Vorname auf unser Helfershirt!
    </p>
    <br>

    <h1>Anleitung</h1>
    <p> Unten findest du ganz viele Arbeiten, bei welchen du uns unterstützen kannst. Mit dem Klick auf Einschreiben, meldest du dich für diesen Job an.<br> Andere Jobs zur gleichen Zeit werden, sobald du eingeschrieben bist, automatisch deaktiviert. Zudem sind Schichten, welche bereits ausgebucht sind, deaktiviert.</p><br>
    <p> In diesen Bereichen gibts Jobs:</p>
    <p
      v-for="bereich in removeDuplicates(schichten,'bereich')"
      :key="bereich.id"
    >{{bereich.bereich}}</p>
    <br>

    <div class="column ">

      <!-- <div :key="" v-for="schicht in orderBy(orderBy(schichten, 'bereich', -1), 'tag')" style="padding: 1rem 0;"> -->
      <div
        :key="schicht.id"
        v-for="schicht in orderedSchichten"
        style="padding: 1rem 0;"
      >
        <!-- li v-for="workOrder in orderBy(filterBy(workOrders, 'sample'), orderTerm, orderDesc)" -->
        <div class="card card-shadow ">
          <header class="card-header">
            <p
              class="card-header-title"
              style="display: block"
            >
              {{schicht.tag}} von {{schicht.zeit.slice(0,5) }} bis {{schicht.zeit.slice(7,13) }} <br> {{ schicht.bereich}}

            </p>

          </header>
          <div class="card-content">
            <div class="content">
              {{schicht.beschreibung}}
              <br>
              <div style="color: hsl(204, 86%, 53%)"> Freie Plätze {{schicht.anzahl}} </div>

              <br>
              <p
                v-for="arbeiter in schicht.arbeiter"
                :key="arbeiter.id"
                class="user-list__sub"
              > {{arbeiter.name}} </p>
            </div>
            <button
              class="button is-link"
              :disabled="sameTime(schicht,schichten) || schicht.anzahl===0 || !checkAnmeldeFenster()"
              v-if="!iAmIn(schicht) "
              v-on:click="einschreiben(schicht,contacts)"
            >Einschreiben</button>
            <button
              class="button is-success"
              v-if="iAmIn(schicht)"
              v-on:click="austragen(schicht,contacts)"
            >Austragen</button>
          </div>

        </div>

      </div>
      <br>
      <h1>Danke, das wars</h1>

      <button
        class="button is-danger"
        v-on:click="backToTop()"
      >Nach oben bitte, zeig mir meine Schichten</button>

      <!-- <div class="user-list" v-for="schicht in schichten" style="background-color:#eaeaea">

      <div class="columns" >

        <div class="column is-8">

          <p class="user-list__header"><strong>{{schicht.bereich}}</strong> am {{schicht.tag}}, {{schicht.zeit}}</p>

          <div class="inner">
            <div class="left">
              <p class="user-list__sub"> {{schicht.beschreibung}}</p>
            </div>

            <div class="right">
              <p class="user-list__sub"><strong>Freie Plätze</strong>: {{schicht.anzahl}}</p>
              <p>In dieser Schicht</p>
              <p v-for="arbeiter in schicht.arbeiter" class="user-list__sub"> {{arbeiter.name}} </p>
            </div>
          </div>
        </div>

      </div>

       <button class="button is-link"  :disabled="sameTime(schicht,schichten) || schicht.anzahl===0" v-if="!iAmIn(schicht)" v-on:click="einschreiben(schicht,contacts)"  >Einschreiben</button>
        <button class="button is-warning" v-if="iAmIn(schicht)" v-on:click="austragen(schicht,contacts)"  >Austragen</button>

    </div> -->

    </div>

  </div>

</template>

<script>
/* eslint-disable */

import editUser from "@/components/editUser";
import firebase from "firebase";
import Moment from "moment";
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import _ from 'lodash'
import router from '../router'
import VModal from 'vue-js-modal'


Vue.use(Vue2Filters, VModal)


export default {
  name: "hello",

  data () {
    return {
      contacts: [],
      schichten: [],
      anmeldefenster: Boolean,
      schicht: [],
      arbeiter: [],
      id: "",
      admin: [],
      mySchichten: [],
      table: [],
      showEditUserModal: false,
      displayName: "",
      telNumber: "",
      shirtsize: "",
      email: "",
      loading: true
    };
  },


  created () {
    this.checkAnmeldeFenster();
    this.checkUser();
    this.getUser();
    this.getTable();
    this.getSchichten();
    this.getUserforShichten();
  },
  computed: {
    bereicheEinzeln: function () {
      return (this.schichten.bereich)
    },
    orderedSchichten: function () {
      return _.orderBy(_.orderBy(this.schichten, 'zeit'), 'tag')
    },

  },


  methods: {

    signUp: function () {
      if (!this.telNumber) {
        alert("Telefonnummer eingeben")
        return
      }
      if (!this.displayName) {
        alert("Name eingeben")
        return
      }
      if (!this.shirtsize) {
        alert("Shirtgrösse auswählen")
        return
      }

      if (this.displayName && this.telNumber && this.shirtsize) {

        blur()

        let user = firebase.auth().currentUser

        firebase
          .firestore()
          .doc("users/" + user.uid)
          .set({
            displayName: this.displayName,
            email: user.email,
            telNumber: this.telNumber,
            shirtsize: this.shirtsize,
            avatar: user.photoURL,
            userID: user.uid,
            admin: false
          })
          .then(() => {

            console.log("User added to Firestore!");
            // this.$router.replace("hello");
            this.checkUser()
            this.getUser()
          })
          .catch(err => {
            console.log(err);
          });
      }
      else return
    },

    removeDuplicates (myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },

    checkUser () {
      var doc = firebase.firestore().collection('users').doc(firebase.auth().currentUser.uid);
      doc.get().then((docData) => {
        if (docData.exists) {
          this.showEditUserModal = false;
          return true
        } else {
          this.showEditUserModal = true;
          // return showEditUserModal = true
        }
      }).catch((fail) => {
        // Either
        // 1. failed to read due to some reason such as permission denied ( online )
        // 2. failed because document does not exists on local storage ( offline )
      });
    },

    getUser () {
      firebase
        .firestore()
        .collection("users")
        .where("userID", "==", firebase.auth().currentUser.uid)
        .get()
        .then(querySnapshot => {
          //    firebase.firestore().collection('users').get().then((querySnapshot) => {
          this.loading = false;
          const contacts = [];
          querySnapshot.forEach(doc => {
            let data = {
              id: doc.id,
              name: doc.data().displayName,
              email: doc.data().email,
              telNumber: doc.data().telNumber,
              userID: doc.data().userID,
              shirtsize: doc.data().shirtsize
            };
            contacts.push(data);
          });
          this.contacts = contacts;
        });
    },
    getUserforShichten () {
      firebase
        .firestore()
        .collection("users")
        .doc(firebase.auth().currentUser.uid)

        .onSnapshot(function (doc) {
          name = doc.data().displayName;
          // console.log("Current data: ", doc.data().displayName);
        });
      return name;
    },

    getSchichten () {
      firebase
        .firestore()
        .collection("Schichten")
        .get()
        .then(querySnapshot => {
          const schichten = [];
          this.loading = false;
          querySnapshot.forEach(doc => {
            let data = {
              id: doc.id,
              tag: doc.data().tag,
              zeit: doc.data().zeit,
              dauer: doc.data().dauer,
              bereich: doc.data().bereich,
              beschreibung: doc.data().beschreibung,
              anzahl: doc.data().anzahl,
              arbeiter: doc.data().arbeiter
            };
            schichten.push(data);
          });
          this.schichten = schichten;
        });
    },

    iAmIn: function (schicht) {
      let uid = firebase.auth().currentUser.uid;
      if (schicht.arbeiter.some(i => i.uid === uid)) {
        return true;
      }
      return false;
    },

    checkAnmeldeFenster () {
      firebase
        .firestore()
        .collection('basics')
        .get()
        .then(querySnapshot => {
          this.loading = false
          querySnapshot.forEach(doc => {
            let data = doc.data().offen
            this.anmeldefenster = data
          })
        })
      if (this.anmeldefenster === true) { return true } else { return false }
    },

    sameTime: function (schicht, schichten) {
      let uid = firebase.auth().currentUser.uid;
      for (var shifts in schichten) {
        var allShifts = schichten[shifts];
        for (var allArbeiter in allShifts.arbeiter) {
          var allEingeschriebenArbeiter = allShifts.arbeiter[allArbeiter];
          if (allEingeschriebenArbeiter.uid === uid) {
            let a = Moment(allShifts.tag + " " + allShifts.zeit.slice(0, 5), "DD.MM.YY HH.mm").format("DD.MM.YY HH.mm");
            let b = Moment(allShifts.tag + " " + allShifts.zeit.slice(0, 5), "DD.MM.YY HH.mm").add(allShifts.dauer, 'h').format("DD.MM.YY HH.mm");
            let c = Moment(schicht.tag + " " + schicht.zeit.slice(0, 5), "DD.MM.YY HH.mm").format("DD.MM.YY HH.mm");
            let d = Moment(schicht.tag + " " + schicht.zeit.slice(0, 5), "DD.MM.YY HH.mm").add(schicht.dauer, 'h').format("DD.MM.YY HH.mm");
            let startA = moment(a, "DD.MM.YY HH.mm");
            let endA = moment(b, "DD.MM.YY HH.mm");
            let startS = moment(c, "DD.MM.YY HH.mm");
            let endS = moment(d, "DD.MM.YY HH.mm");
            let inpA = moment.range(startA, endA)
            let inpS = moment.range(startS, endS)
            if (
              // allShifts.zeit === schicht.zeit &&
              // allShifts.tag === schicht.tag
              inpA.overlaps(inpS)
            ) {
              return true;
            }
            // if (
            //   // allShifts.zeit === schicht.zeit &&
            //   // allShifts.tag === schicht.tag

            //   inpA.overlaps(inpS)
            // ) {
            //   return true;
            // }
          }
        }
      }
    },
    einschreiben: function (schicht) {
      this.getUserforShichten;
      // Create a reference to the SF doc.
      let uid = firebase.auth().currentUser.uid;
      let name = this.getUserforShichten();
      let index = uid;
      const newArbeiter = { uid, name };
      var schichtRef = firebase
        .firestore()
        .collection("Schichten/")
        .doc(schicht.id);
      return firebase
        .firestore()
        .runTransaction(function (transaction) {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(schichtRef).then(function (sfDoc) {
            if (!sfDoc.exists) {
              throw "Document does not exist!";
            }
            else if (sfDoc.data().anzahl === 0) {
              alert("Leider bereits besetzt. Bitte Seite neu laden")
              location.reload();
              throw "schon Ausgebucht"
            }
            else if (sfDoc.data().arbeiter.some(i => i.uid === uid)) {
              alert("Upps du bist schon in dieser Schicht")
              location.reload();
              throw "schon Ausgebucht"
            }
            var newAnzahl = sfDoc.data().anzahl - 1;
            transaction.update(schichtRef, { anzahl: newAnzahl });
            const arbeiter = sfDoc.data().arbeiter;
            arbeiter.push(newArbeiter);
            transaction.update(schichtRef, { arbeiter });
          });
        })
        .then(this.getSchichten)
        .then(this.getTable)
        .then(function () {
          console.log("Transaction successfully committed!");
        })
        .catch(function (error) {
          console.log("Transaction failed: ", error);
        });
    },

    austragen (schicht) {
      // Create a reference to the SF doc.
      let uid = firebase.auth().currentUser.uid;
      let name = this.getUserforShichten();
      const newArbeiter = { name };
      var schichtRef = firebase
        .firestore()
        .collection("Schichten/")
        .doc(schicht.id);
      return firebase
        .firestore()
        .runTransaction(function (transaction) {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(schichtRef).then(function (sfDoc) {
            if (!sfDoc.exists) {
              throw "Document does not exist!";
            }
            else if (sfDoc.data().arbeiter.some(i => i.uid === uid)) {
              var newAnzahl = sfDoc.data().anzahl + 1;
              transaction.update(schichtRef, { anzahl: newAnzahl });
              const arbeiter = sfDoc.data().arbeiter.filter(i => i.uid !== uid);
              transaction.update(schichtRef, { arbeiter });
            } else {
              alert("UPPS du bist bereits ausgetragen")
              location.reload();
              throw "Bereits ausgetragen";            }
          });
        })
        .then(this.getSchichten)
        .then(this.getTable)
        .then(function () {
          console.log("Transaction successfully committed!");
        })
        .catch(function (error) {
          console.log("Transaction failed: ", error);
        });
    },

    // collectSchichten: function () {
    //   console.log("collectSchichten start")
    //   let myUid = firebase.auth().currentUser.uid;

    //   return firebase
    //     .firestore()
    //     .collection("Schichten")
    //     .get()
    //     .then(querySnapshot => {
    //       const alleSchichten = [];
    //       this.loading = false;
    //       querySnapshot.forEach(doc => {
    //         let data = {
    //           id: doc.id,
    //           tag: doc.data().tag,
    //           zeit: doc.data().zeit,
    //           bereich: doc.data().bereich,
    //           beschreibung: doc.data().beschreibung,
    //           anzahl: doc.data().anzahl,
    //           arbeiter: doc.data().arbeiter,

    //         };
    //         alleSchichten.push(data);
    //       });
    //       var table = [];
    //       if (table.lenght === 0) {
    //         for (const i in alleSchichten) {

    //           for (const j in alleSchichten[i].arbeiter) {


    //             if (alleSchichten[i].arbeiter[j].uid === myUid) {
    //               var object = {}

    //               object.slot = alleSchichten[i].id
    //               table.push(object)
    //               // console.log(alleSchichten[i].id)
    //               // alert(alleSchichten[i].id)

    //               this.table = table
    //             }




    //             // console.log(alleSchichten[i].id + alleSchichten[i].arbeiter[j].uid)

    //           }


    //         }
    //         console.log(this.table)
    //       }








    //     })


    // },





    getTable () {
      var table = [];
      let myUid = firebase.auth().currentUser.uid;
      firebase
        .firestore()
        .collection("Schichten")
        .get()
        .then(querySnapshot => {
          const alleSchichten = [];
          this.loading = false;
          querySnapshot.forEach(doc => {
            let data = {
              id: doc.id,
              tag: doc.data().tag,
              zeit: doc.data().zeit,
              bereich: doc.data().bereich,
              beschreibung: doc.data().beschreibung,
              anzahl: doc.data().anzahl,
              arbeiter: doc.data().arbeiter,
            };
            alleSchichten.push(data);
          });
          if (table.length === 0) {
            for (const i in alleSchichten) {
              for (const j in alleSchichten[i].arbeiter) {
                if (alleSchichten[i].arbeiter[j].uid === myUid) {
                  var object = {}
                  object.id = alleSchichten[i].id;
                  object.bereich = alleSchichten[i].bereich;
                  object.tag = alleSchichten[i].tag;
                  object.zeit = alleSchichten[i].zeit;
                  table.push(object);
                }
              }
            }
          }
          this.table = table
        })
    },

    backToTop: function () {
      var timeOut;
      if (document.body.scrollTop != 0 || document.documentElement.scrollTop != 0) {
        window.scrollBy(0, -50);
        timeOut = setTimeout(this.backToTop(), 100);
      }
      else clearTimeout(timeOut)
    },

    logout: function () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 30px;
  margin: 30px 0;
}
.user-list {
  margin-top: 30px;
  background-color: white;
  padding: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
  .column {
    height: 120px;
  }
  .inner {
    .left {
      width: 50%;
      float: left;
      text-align: left;
    }
    .right {
      width: 50%;
      float: left;
      text-align: left;
      p {
        width: 100%;
        text-align: left;
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      background: #4b75ff;
    }
  }
  .user-list__header {
    font-size: 20px;
    font-weight: 700;
  }
  .user-list__sub {
    font-size: 15px;
    margin-top: 10px;
  }
}
@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
.animated-background__header {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-name: placeHolderShimmer;
  animation-name: placeHolderShimmer;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: #eeeeee;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(8%, #eeeeee),
    color-stop(18%, #dddddd),
    color-stop(33%, #eeeeee)
  );
  background: -webkit-linear-gradient(
    left,
    #eeeeee 8%,
    #dddddd 18%,
    #eeeeee 33%
  );
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  -webkit-background-size: 800px 104px;
  background-size: 800px 104px;
  height: 20px;
  width: 400px;
  position: relative;
}
.animated-background__sub {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-name: placeHolderShimmer;
  animation-name: placeHolderShimmer;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: #eeeeee;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(8%, #eeeeee),
    color-stop(18%, #dddddd),
    color-stop(33%, #eeeeee)
  );
  background: -webkit-linear-gradient(
    left,
    #eeeeee 8%,
    #dddddd 18%,
    #eeeeee 33%
  );
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  -webkit-background-size: 800px 104px;
  background-size: 800px 104px;
  height: 20px;
  width: 200px;
  position: relative;
}
</style>
